import { render, staticRenderFns } from "./upLoad.vue?vue&type=template&id=72c0eea8&scoped=true&"
import script from "./upLoad.vue?vue&type=script&lang=js&"
export * from "./upLoad.vue?vue&type=script&lang=js&"
import style0 from "./upLoad.vue?vue&type=style&index=0&id=72c0eea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c0eea8",
  null
  
)

export default component.exports